/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { Dispatch, SetStateAction } from "react";
import { Offers } from "../../types/General";
import { OFFER_STATUS } from "../../utils/enums";
import { Button } from "@mui/material";
import moment from "moment";
import { totalValue } from "../../utils/validations";

type props = {
  rows: Offers[];
  setPage: Dispatch<SetStateAction<number>>;
  page: number;
  loading: boolean;
  count: number;
  handlePageChange: (event: any, newPage: number) => void;
  setDocOpen: Dispatch<SetStateAction<boolean>>;
  setSelectedQuatation: Dispatch<SetStateAction<string>>;
};

const OffersRejectedList = ({
  count,
  handlePageChange,
  loading,
  page,
  rows,
  setPage,
  setDocOpen,
  setSelectedQuatation,
}: props) => {
  const navigate = useNavigate();

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 220,
      field: "maintenance",
      headerName: "Maintenance Team Detail",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block click_action">
            <p>
              <b>{row?.user?.fullName || "-"}</b>{" "}
              <span>{row?.user?.email || "-"}</span>
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "offered",
      headerName: "Quoted Price",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        return (
          <p className="c_primary">
            <strong>AED {row?.price || "0"}</strong>
          </p>
        );
      },
    },
    {
      minWidth: 140,
      field: "commission",
      headerName: "Commission",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <p className="c_success">
            <strong> {row?.adminCommission || "0"} %</strong>
          </p>
        );
      },
    },
    {
      minWidth: 140,
      field: "total",
      headerName: "Total",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <p className="c_success">
            <strong>
              AED{" "}
              {totalValue(
                Number(row?.price || 0),
                Number(row?.adminCommission || 0)
              )}
            </strong>
          </p>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "est",
      headerName: "Est. Timeline",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        return <p className="c_primary">{row?.time || "0"} hours</p>;
      },
    },
    {
      minWidth: 150,
      field: "date",
      headerName: "Offer Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <p className="c_primary">
            <strong>{moment(row?.createdAt).format("DD MMM YYYY")}</strong>
          </p>
        );
      },
    },
    {
      minWidth: 150,
      field: "status",
      headerName: "Status",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <span className="btn_text c_success">
            {OFFER_STATUS[row?.status || 3]}
          </span>
        );
      },
    },

    {
      flex: 1,
      minWidth: 150,
      field: "quoatation",
      headerName: "Quotation",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        return (
          <Button
            className="btn sm btn_primary"
            onClick={() => {
              if (row?.quoatation) {
                window.open(row.quoatation, "_blank");
              }
            }}
          >
            View
          </Button>
          // <Button
          //   className="btn sm btn_primary"
          //   onClick={() => {
          //     setSelectedQuatation(row?.quoatation || "");
          //     setDocOpen(true);
          //   }}
          // >
          //   View
          // </Button>
        );
      },
    },
  ];

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns}
          rows={rows}
          count={count}
          page={page}
          onPageChange={handlePageChange}
          loading={loading}
        />
      </div>
    </>
  );
};

export default OffersRejectedList;
